import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled from 'styled-components';

import { ShippingMethods } from '@/enums/shippingMethod';

export type StatusBadgeProps = {
    primaryText: string | JSX.Element;
    secondaryText: string | JSX.Element;
    shippingMethod?: ShippingMethods;
    trackingLink?: string;
};

const StatusBadge = ({ primaryText, secondaryText, shippingMethod, trackingLink }: StatusBadgeProps) => {
    return (
        <Badge>
            <H5 className="flex">{primaryText}</H5>
            <section>
                <BodySecondary color="secondary">{secondaryText}</BodySecondary>
                {shippingMethod === ShippingMethods.LiveShipping && Boolean(trackingLink) && (
                    <StyledLink
                        href={trackingLink}
                        size="sm"
                        target="_blank"
                    >
                        View Tracking History
                    </StyledLink>
                )}
            </section>
        </Badge>
    );
};

export default StatusBadge;

const Badge = styled.section`
    display: flex;
    flex-direction: column;
    max-width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        max-width: 760px;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletWidth}) {
        max-width: 700px;
    }
`;

const StyledLink = styled(Link)`
    margin-left: 5px;
`;
